import {
  createTabFilAriane,
  getLibelleEtatDevisCommandeFacture, setInfoFactureWithCommande, updateObjectFilAriane,
  getToolTipSignatureInfo,
} from '@/services/dcf/detail/filAriane/utilsFunctionsFilAriane';
import { get as getCommande, getAll as getAllCommande } from '@/api/commande';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import {
  DEVIS_COMMANDE_ETAT,
  ETAT_FACTURE,
  ETAT_FACTURE_PARTIELLEMENT,
  ETAT_SANSSUITE,
  SENS_VENTE,
} from '@/configuration/devisConf';

export default async function createFilArianeDevis(devis, societeId, signatureInfo) {
  const tabFilAriane = createTabFilAriane();
  const customClassMarker = devis.etat === ETAT_SANSSUITE ? 'is-danger has-text-danger' : null;
  const icon = devis.etat === ETAT_SANSSUITE ? 'close-thick' : null;
  updateObjectFilAriane(tabFilAriane[0], tabFilAriane[0].libelle, null, null,
    true, customClassMarker,
    getLibelleEtatDevisCommandeFacture(devis.etat, DEVIS_COMMANDE_ETAT),
    icon, null, null, signatureInfo);
  const commandes = (await (getAllCommande({
    maxResultCount: NO_PAGINATION,
    query: { referenceIds: [devis.id], sens: SENS_VENTE, societeId: societeId },
  }))).data.result.items;
  if (commandes.length === 0) return tabFilAriane;
  if (commandes.length === 1) {
    const commande = (await getCommande(commandes[0].id)).data.result;
    const toolTipSignatureInfo = await getToolTipSignatureInfo(commande.id);
    const customClassMarkeCommande = commande.etat === ETAT_SANSSUITE ? 'is-danger has-text-danger' : null;
    const iconCommande = commande.etat === ETAT_SANSSUITE ? 'close-thick' : 'check-bold';
    updateObjectFilAriane(tabFilAriane[1], tabFilAriane[1].libelle, 'c.bodac.commandes', { id: commande.id }, true, customClassMarkeCommande, getLibelleEtatDevisCommandeFacture(commande.etat, DEVIS_COMMANDE_ETAT), iconCommande,
      null, null, toolTipSignatureInfo);
    await setInfoFactureWithCommande(commande, tabFilAriane);
    return tabFilAriane;
  }
  updateObjectFilAriane(tabFilAriane[1], 'detailCommande.multiTypeCommande', 'l.bodac.commandes-listeReferencesId', { referenceId: devis.id }, true, null, null, 'check-bold', null, { nb: commandes.length });
  if (commandes.some((commande) => {
    return commande.etat === ETAT_FACTURE || commande.etat === ETAT_FACTURE_PARTIELLEMENT;
  })) {
    updateObjectFilAriane(tabFilAriane[2], 'detailFacture.multiTypeFacture', 'l.bodac.factures-referencesIds', { referenceIds: commandes.map(commande => commande.id).join('|') }, true, null, null, 'check-bold');
  }
  return tabFilAriane;
}
